import { render, staticRenderFns } from "./SeatList.vue?vue&type=template&id=1678d9c5&scoped=true&"
import script from "./SeatList.vue?vue&type=script&lang=js&"
export * from "./SeatList.vue?vue&type=script&lang=js&"
import style0 from "./SeatList.vue?vue&type=style&index=0&id=1678d9c5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678d9c5",
  null
  
)

export default component.exports